import { useQuery } from "@tanstack/react-query";
import { Dayjs } from "dayjs";

import { MeasurementTypes } from "../../@types/Measurements";
import { IPatientTreatment } from "../../@types/Treatments";
import { treatmentsService } from "../../services/treatmentsService";

export function useTreatments(
  patientId: number,
  fromDate: Dayjs,
  toDate: Dayjs,
  measurementType?: MeasurementTypes
) {
  const { data, isError, isFetching, refetch, isRefetching } = useQuery<
    IPatientTreatment[] | undefined
  >({
    queryKey: [`patient-treatments`, patientId],
    queryFn: async () => {
      if (measurementType !== "nebulizer") return [];

      const data = await treatmentsService.getPatientTreatmentsData(
        patientId,
        fromDate,
        toDate
      );

      return data;
    },
  });

  return {
    treatments: data ?? [],
    isTreatmentsFetching: isFetching,
    isTreatmentsError: isError,
    treatmentsRefetch: refetch,
    isTreatmentsRefetching: isRefetching,
  };
}
